import { ReactNode, useEffect, useMemo, useState } from 'react'
import GridLayout from '../../GridLayout'
import { IGridItem, TLayout } from '../../GridLayout/grid.types'
import EquipmentStatisticsWidget from '../../Widgets/EquipmentStatisticsWidget'
import MapWidget from '../../Widgets/MapWidget'
import RecentNotificationsWidget from '../../Widgets/RecentNotificationsWidget'
import RoutesHistoryWidget from '../../Widgets/RoutesHistoryWidget'
import UpcomingMaintenanceEventWidget from '../../Widgets/UpcomingMaintenanceEventWidget'
import mainGridLayoutConstants from './mainGridLayout.constants'
import Button from '@/shared/Buttons/Button'
import ArrowGoBack from '@/assets/icons/arrowGoBackLine.svg?react'
import AiIcon from '@/assets/icons/ai-icon.svg?react'
import mainGridLayoutUtils from './mainGridLayout.utils'
import usePersistentState from '@/shared/hooks/usePersistentState'
import gridLayoutUtils from '../../GridLayout/gridLayout.utils'
import FavoriteEquipmentWidget from '../../Widgets/FavoriteEquipmentWidget'
import { useNavigate } from 'react-router-dom'
import urls from '@/navigation/urls.ts'

const MainGridLayout = () => {
  const navigate = useNavigate()

  const widgets: Record<IGridItem['key'], ReactNode> = {
    'map-widget': <MapWidget />,
    'favorite-equipment-widget': <FavoriteEquipmentWidget />,
    'recent-notifications-widget': <RecentNotificationsWidget />,
    'upcoming-maintenance-event-widget': <UpcomingMaintenanceEventWidget />,
    'routes-history-widget': <RoutesHistoryWidget />,
    'equipment-statistics-widget': <EquipmentStatisticsWidget />,
  }

  const [layoutTemplateState, setLayoutTemplateState] = usePersistentState(
    { layoutTemplate: mainGridLayoutConstants.initLayout, ver: mainGridLayoutConstants.сurrentVersion },
    'main/layoutTemplateState',
    'localstorage'
  )
  const [isLayoutChange, setIsLayoutChange] = useState(false)

  const layout = useMemo(() => {
    return mainGridLayoutUtils.generateLayout(widgets, layoutTemplateState.layoutTemplate)
  }, [layoutTemplateState])

  const resetLayout = () => {
    setLayoutTemplateState({
      layoutTemplate: mainGridLayoutConstants.initLayout,
      ver: mainGridLayoutConstants.сurrentVersion,
    })
    setIsLayoutChange(false)
  }

  const onLayoutChange = (layout: TLayout) => {
    if (gridLayoutUtils.isLayoutsEqual(layout, layoutTemplateState.layoutTemplate)) return
    const layoutTemplate = layout.map((item) => ({ ...item, children: null, bounds: null }))
    setLayoutTemplateState((prev) => ({
      layoutTemplate,
      ver: prev.ver,
    }))
    setIsLayoutChange(true)
  }

  useEffect(() => {
    if (
      !layoutTemplateState.ver ||
      !layoutTemplateState.layoutTemplate ||
      layoutTemplateState.ver !== mainGridLayoutConstants.сurrentVersion
    ) {
      setLayoutTemplateState({
        layoutTemplate: mainGridLayoutConstants.initLayout,
        ver: mainGridLayoutConstants.сurrentVersion,
      })
    } else {
      setIsLayoutChange(!gridLayoutUtils.isLayoutsEqual(layout, mainGridLayoutConstants.initLayout))
    }
  }, [])

  return (
    <>
      <div className="inline-flex-gap gap16">
        <Button
          onClick={() => navigate(urls.aiAssistant)}
          size="default"
          type="tetriary"
          icon={<AiIcon width="16px" height="16px" />}
          text="AI Лифтер"
        />
        {isLayoutChange && (
          <Button
            onClick={resetLayout}
            size="default"
            type="default"
            icon={<ArrowGoBack width="16px" height="16px" />}
            text="Исходное расположение"
          />
        )}
      </div>
      <GridLayout
        layout={layout}
        positionParams={mainGridLayoutConstants.initPosParams}
        onLayoutChange={onLayoutChange}
      />
    </>
  )
}

export default MainGridLayout
// С чем может быть связана ошибка "Охрана шахты"?
